import {template} from 'lodash';

const themeCustomize = window.themeCustomize || null;
// console.log('themeCustomize', themeCustomize);

$('[data-wp_setting_text]').each(
  function () {
    const elSettingId = $(this).data('wp-setting');
    if (themeCustomize) {
      if (themeCustomize.hasOwnProperty(elSettingId)) {
        let text = themeCustomize[elSettingId];
        if (this.hasAttribute('data-ignore-br')) {
          text = text.replace(/[<]br[^>]*[>]/gi, " ")
        }
        $(this).html(text);
      }
    }
  }
);

$('a[href^="tel:"] [data-wp-setting="abcgym_contacts__phone"]').each(
  function () {
    const elSettingId = $(this).data('wp-setting');
    if (themeCustomize) {
      if (themeCustomize.hasOwnProperty(elSettingId)) {
        $(this).closest('a[href^="tel:"]')
          .attr('href', 'tel:' + themeCustomize[elSettingId].replace(/\s/g, '').split('-').join(''))
      }
    }
  }
);


const $bannerCarousel = $('#bannerCarouselTmpl');
const bannerTmpl = template($bannerCarousel.html());
const bannerContext = themeCustomize ? themeCustomize.bannerContext :
  {
    items: [
      {
        title: 'Акция',
        background: './img/section1-bg.png',
        text: `В ноябре приглашаем юных спортсменов на бесплатное занятие на единственном в России
             <strong>суперсовременном батуте Springfree</strong> c приставкой дополненной реальности!`,
        hasBtn: true
      },
      {
        title: 'Baby Day',
        background: './img/banner-2.jpg',
        text: `19 ноября с 11 до 14 часов - день открытых дверей! Играем и учимся всей семьёй по уникальной
                    стимулирующей методике <strong>ABC&nbsp;GYM</strong>.
                    Обучение родителей, гимнастические упражнения и массаж для малышей в игровой форме, сенсорика.
                    Консультации педиатра, общение, вкусняшки. Вход свободный!`,
        hasBtn: false
      },
    ]
  };

if (bannerContext) {
  $bannerCarousel.after(bannerTmpl(bannerContext));
}



// WEBPACK FOOTER //
// ./src/js/theme-customization.js